"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const app_service_1 = require("../../commons/app.service");
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const core_2 = require("@ngx-translate/core");
const global_1 = require("../../commons/global");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const map_service_1 = require("../../commons/map.service");
// generic helpers
const Constants_1 = require("./../../commons/Constants");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
class IntegrationsComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, router, snackBar, dialog, activeRoute, translate, mapService, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.activeRoute = activeRoute;
        this.translate = translate;
        this.mapService = mapService;
        //apis:ProcessorAPI[]     = []
        // sub:Subscription  ;; commented out as it's also defined in AppBaseComponent class
        this.apiTypes = [, global_1.APITypes.SDK.NAME, global_1.APITypes.Datum360.NAME, global_1.APITypes.Trackonus.NAME, global_1.APITypes.Photoscan.NAME, global_1.APITypes.CapturingReality.NAME, global_1.APITypes.Agronomeye.NAME];
        this.availApiTypes = [];
        this.AGRONOMEYE = global_1.APITypes.Agronomeye.NAME;
        // our secret clipboard
        this.clipboardText = '';
        this.sdks = [];
        this.otherApis = [];
        this.addSubscription('onActiveAccountReady', this.fourD.onActiveAccountReady().subscribe(s => {
            // Refresh available Apis
            this.refreshApis();
        }));
    }
    onReady() {
        this.sdks = this.fourD.apis.filter(ap => ap.processorImpl == 'SDK' && ap.account.id == this.fourD.activeTeam.id);
        this.otherApis = this.fourD.apis.filter(ap => ap.processorImpl != 'SDK' && ap.account.id == this.fourD.activeTeam.id);
    }
    refreshApis() {
        this.availApiTypes = [global_1.APITypes.SDK.NAME];
        // Refresh available apis to be created.
        //this.apiTypes.forEach(a => {
        //    if ( !this.hasApiByType(a) ) this.availApiTypes.push(a)
        //});
        // hide HangOn / waiting box (if open)
        Constants_1.Constants.hideHangOn();
    }
    hasApiByType(type) {
        // If no apis then return false
        if (!this.fourD.apis)
            return false;
        var res = false;
        // Go through apis list and search for the type
        for (var i = 0; i < this.fourD.apis.length; i++) {
            if (this.fourD.apis[i].type == type) {
                res = true;
                break;
            }
        }
        return res;
    }
    copyToClipboard(inputElement) {
        // get the value
        let val = inputElement.value;
        // find the clipboard
        let cb = document.getElementById('clipboard');
        // transfer values
        cb.value = val;
        this.clipboardText = val;
        // select the clipboard field, and make a copy
        cb.select();
        document.execCommand('copy');
        // select back to the original field
        inputElement.select();
        inputElement.setSelectionRange(0, 0);
        // assume success
        this.openSnackBarSuccess('GENERIC.COPIED');
    }
    saveApi(api) {
        api.saveObservable().pipe(operators_1.mergeMap(res => {
            return this.fourD.activeTeam.enableDisableApi(api.type, true);
        })).subscribe(succ => this.openSnackBarSuccess("API.SAVE_SUCC"), err => this.openSnackBarError("ERROR.VASAT", "", err));
    }
    deleteApi(api, index) {
        this.openDialog('GENERIC.CONFIRM', 'API.DEL_CONF', 'GENERIC.YES', 'GENERIC.CANCEL').subscribe(s => {
            if (s) {
                api.destroyObservable().pipe(operators_1.mergeMap(res => {
                    return this.fourD.activeTeam.enableDisableApi(api.type, false);
                })).subscribe(succ => {
                    this.fourD.apis.splice(index, 1);
                    this.sdks = this.sdks.filter(s => s != api);
                    // refresh new api pull down
                    this.refreshApis();
                    this.openSnackBarSuccess("API.DEL_SUCC");
                }, err => this.openSnackBarError("ERROR.VASAT", "", err));
            }
        });
    }
    addApi(apiType) {
        // Create the new api object
        let newApi = new _4d_mapper_1.ProcessorAPI(this.service.V).set({ type: apiType, processorImpl: global_1.APITypes[apiType].IMPL });
        // Specify default name if not ProcessorAPI
        if (apiType != global_1.APITypes.ProcessorAPI.NAME)
            newApi.name = apiType;
        if (apiType == 'Photoscan' || apiType == 'CapturingReality' || apiType == 'SDK') {
            newApi.saveObservable().subscribe(s => {
                this.fourD.apis.push(newApi);
                if (apiType == 'SDK')
                    this.sdks.push(newApi);
            });
        }
        else {
            // push to the current list of apis
            this.fourD.apis.push(newApi);
        }
        // refresh new api pull down
        this.refreshApis();
    }
    testAPI(apiType) {
        apiType.saveObservable().subscribe(_ => this.fourD.V.api('/remote/' + apiType.id + '/test').subscribe(s => this.openSnackBarSuccess('GENERIC.CONNECT_OK'), e => this.openSnackBarError('GENERIC.CONNECT_ERROR2 ' + e)));
    }
}
exports.IntegrationsComponent = IntegrationsComponent;
